<template>
  <div class="charts-page">
    <div class="row">
      <div class="flex md12 xs12">
        <sp-360-panel
          class="chart-widget"
          :title="$t('menu.solicitacoes-setores')">
          <iframeBI :fonte='fonte'> </iframeBI>       
        </sp-360-panel>
      </div>
    </div>
  </div>
</template>

<script>

import constantes from '@/utils/ConstantesGlobais'
import mapaDeCalor from '@/services/MapaDeCalor'
import MetodosGlobais from '@/utils/MetodosGlobais'
import _ from 'lodash'
import iframeBI  from '@/components/iframe/implementacoes/iframeBI'
import Sp360Panel from '@/components/ui/sp360-panel/sp360-panel'

export default {
  name: 'solicitacoes-setores',
  components: {
    iframeBI,
    Sp360Panel,
  },
  data: () => ({
      dados: {},
      chartData: {},
      bChartData: {},
      options: {},
      fonte: ''
  }),
  created(){
      this.buscarLinkBi();
  },
  methods: {
      buscarLinkBi() {
        this.$store.dispatch('iframeDashboard/buscarUrlIframe', {nome:constantes.LINK_IFRAME.LICENCIAMENTO_EMPRESA.SOLICITACAO_SETORES})
          .then((retorno)=>{
             this.fonte = retorno.data.url;
          }).catch((error) => {
           console.error(error)
          });
      },
  },
}
</script>

<style lang="scss">
.widget.chart-widget {
  .widget-body {
    height: 550px;
  }
}
</style>
